module.exports = __webpack_public_path__ + "static/media/DSC_0370.131bed0a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/animals/DSC_0370.jpg
// module id = 578
// module chunks = 0